module.exports = __webpack_public_path__ + "static/media/furba4.4a64d84f.wav";